/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ios': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M778.752 543.744c0-124.416 102.4-184.32 102.4-184.32-59.392-81.408-144.896-97.28-177.664-97.28-75.264-5.632-145.408 43.52-182.784 43.52-37.888 0-96.768-43.52-161.28-43.52-80.896 0-156.16 48.64-199.168 124.416-86.016 151.552-21.504 368.128 59.392 492.544 43.008 54.272 91.136 119.296 156.16 119.296 59.392 0 86.016-37.888 156.16-37.888 75.264 0 96.768 37.888 161.28 37.888s107.52-59.392 150.528-119.296c48.128-70.144 64.512-135.168 64.512-140.8-.512 0-129.536-48.64-129.536-194.56zM654.848 180.736c37.888-43.52 59.392-97.28 53.76-157.184-48.128 0-107.52 32.256-144.896 75.776-32.256 32.256-59.392 92.16-48.128 146.432 53.76 5.12 107.52-27.136 139.264-65.024z" _fill="#8E9092"/>'
  }
})
